import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=52544a6e&scoped=true&"
import script from "./Popover.vue?vue&type=script&lang=js&"
export * from "./Popover.vue?vue&type=script&lang=js&"
import style0 from "./Popover.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Popover.vue?vue&type=style&index=1&id=52544a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52544a6e",
  null
  
)

export default component.exports